import { PaginationFeaturesDto } from "./paginationfeaturesdto";
import { User } from "./user";

export class UserRequest {

    user: User = new User();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});

}
